<template>
    <div class="ListView__container">
        <ThePage :class-name="'ListView'"
                 :title="'LIST__LIST'">
            <template slot="left-action">
                <!--BACK-->
                <BaseNavigationButton :icon="'icon-left'"
                                      @click="back()" />
            </template>
            <template slot="right-action">
                <!--ADD-->
                <BaseNavigationButton :label="'LIST__ADD'"
                                      :icon="'icon-plus'"
                                      @click="open()" />

            </template>
            <div class="ListView__body" v-show="isLoaded">
                <ListItem v-for="(item, index) in items"
                          :key="item.id"
                          :name="item.name"
                          :sex="item.sex"
                          @click="open(item.id)" />
            </div>
            <BaseLoader v-show="!isLoaded"/>
        </ThePage>
        <!--LIST ITEM MODAL-->
        <ListItemModal v-if="listItemVisible" />
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import ThePage from '../components/common/ThePage.vue';
    import BaseNavigationButton from '../components/common/BaseNavigationButton.vue';
    import BaseLoader from '../components/common/BaseLoader.vue';
    import ListItem from '../components/list/ListItem.vue';
    import ListItemModal from '../components/list/ListItemModal.vue';

    export default {
        name: 'ListView',
        components: {
            ThePage,
            BaseNavigationButton,
            BaseLoader,
            ListItem,
            ListItemModal
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.getItems();
            });
        },
        computed: {
            ...mapState({
                isLoaded: s => s.list.isLoaded,
                items: s => s.list.items,
                listItemVisible: s => s.listItem.visible
            })
        },
        methods: {
            ...mapActions({
                getItems: 'list/getItems',
                back: 'list/back',
                open: 'listItem/open'
            })
        }
    };
</script>

<style>
    .ListView__container {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .ListView__body {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// ListView.vue?27f178d0